import styles from './ProductCardTabs.module.scss';
import { scrollToElement } from '@components/utils';
import { useMedia } from '@components/hooks';
import { Button, FontAwesomeProIcon } from '@wienenergiegithub/ui-next';
import { TabList, Tab, TabPanel, useTabStore } from '@ariakit/react';
import classNames from 'classnames';
import React, { Children } from 'react';

const ProductCardTabs = ({ children, productCardsRef }) => {
  const tab = useTabStore();
  const activeId = tab.useState('activeId');
  const isMobile = useMedia('(max-width: 767px)');

  const handleTabChange = () => {
    tab.setSelectedId(activeId === 'overview' ? 'details' : 'overview');
    scrollToElement(productCardsRef.current, isMobile, -42);
  };

  return (
    <div className={styles.container}>
      {Children.map(children, child => (
        <TabPanel store={tab} tabId={child.tabId}>
          {child}
        </TabPanel>
      ))}
      <div className={styles.controlsContainer}>
        <TabList className={styles.paginationContainer} store={tab}>
          <Tab
            id="overview"
            render={
              <Button
                className={classNames(styles.bullet, {
                  [styles.bulletActive]: activeId === 'overview',
                })}
                shape="bubble"
                theme="secondary"
              />
            }
          />
          <Tab
            id="details"
            render={
              <Button
                className={classNames(styles.bullet, {
                  [styles.bulletActive]: activeId === 'details',
                })}
                shape="bubble"
                theme="secondary"
              />
            }
          />
        </TabList>
        <Button
          aria-label="Zurück"
          className={styles.navButton}
          onClick={handleTabChange}
          theme="secondary"
          variant="link"
        >
          {activeId === 'details' ? (
            <span>
              <FontAwesomeProIcon icon="chevron-left" /> Zurück
            </span>
          ) : (
            <span>
              Details <FontAwesomeProIcon icon="chevron-right" />
            </span>
          )}
        </Button>
      </div>
    </div>
  );
};

export default ProductCardTabs;
